'use strict';
var slickConfigs = require('../config/slickConfigs');
var util = require('../util/utils');
var imagesPerRow = $('#category-tiles-per-row').data('category-items') || 6;
var glide = require('org/config/glide');
var glideConfigs = require('site/config/glideConfigs');


/**
 * Init globally reusable carousels
 */

module.exports = {
    heroCarousels: function () {
        // prevents collision with content asset js
        // if ($('.hero-caro').length && !$('#hero-carousel').length) {
        //     $('.hero-caro').on('init reInit', function (event, slick) {
        //         slickConfigs.reinitPagination(event, slick, 1);
        //     }).slick(slickConfigs.hero);
        //     util.smartResize(function () {
        //         slickConfigs.reinitPagination(event, $('.hero-caro').slick('getSlick'), 1);
        //     });
        // }
    },
    blogProductTileCarousels: function () {
        // const $this = this;
        if ($('.product-tile-caro, .promotedProducts').length) {
            glide.sameClassMultiCarousel('.product-tile-caro', glideConfigs.recommendation);
            // many product tile sliders can exist on a page; loop through them to init individually
            // $('.product-tile-caro, .promotedProducts').not('.slick-initialized').each(function () {
            //     var $slider = $(this);
            //     var defaultConfig = slickConfigs.productTiles;
            //     if ($slider.hasClass('recommendation')) {
            //         defaultConfig.slide = '.grid-tile';
            //     }

            //     // each slider target only that slider's controls
            //     var $sliderControls = $slider.next('.product-carousel-arrows');

            //     // update slider config to use unique controls and prevent multiple sliders on same page from affecting each other
            //     slickConfigs.productTiles.appendDots = $sliderControls.find('.slick-dots-custom');
            //     slickConfigs.productTiles.prevArrow = $sliderControls.find('.slick-arrows-custom-prev');
            //     slickConfigs.productTiles.nextArrow = $sliderControls.find('.slick-arrows-custom-next');

            //     $slider.on('init reInit', function (event, slick) {
            //         slickConfigs.reinitPagination(event, slick, 4);
            //     }).slick(defaultConfig);

            //     // watch DOM for PI recommendations content
            //     if ($slider.hasClass('recommendation')) {
            //         $this.observeEinsteinCarousels();
            //     }

            //     util.smartResize(function () {
            //         slickConfigs.reinitPagination(event, $slider.slick('getSlick'), 4);
            //     });
            // });
        }

        if ($('.product-tile-caro-mobile-hero').length) {
            $('.product-tile-caro-mobile-hero').not('.slick-initialized').each(function (idx) {
                var $slider = $(this);
                var sliderID = 'mobileTileSlider' + idx;
                var defaultConfig = slickConfigs.productTilesHeroMobile;
                $slider.attr('id', sliderID);
                var $sliderControls = $(`#${sliderID}`).next('.product-carousel-arrows');
                slickConfigs.productTilesHeroMobile.appendDots = $sliderControls.find('.slick-dots-custom');
                slickConfigs.productTilesHeroMobile.prevArrow = $sliderControls.find('.slick-arrows-custom-prev');
                slickConfigs.productTilesHeroMobile.nextArrow = $sliderControls.find('.slick-arrows-custom-next');

                $slider.on('init reInit', function (event, slick) {
                    slickConfigs.reinitPagination(event, slick, 4);
                }).slick(slickConfigs.productTilesHeroMobile);

                util.smartResize(function () {
                    slickConfigs.reinitPagination(event, $slider.slick('getSlick'), 4);
                });

                slickConfigs.productTilesHeroMobile = defaultConfig;
            });
        }
    },
    observeEinsteinCarousels: function () {
        // declare constants
        const einsteinSelector = '[id^="cq_recomm_slot"]';
        const einsteinElements = document.querySelectorAll(einsteinSelector);
        const $this = this;
        // callback
        const mutationCallback = (mutationList, observer) => {
            if (mutationList.length) {
                observer.disconnect();
                $this.blogProductTileCarousels();
            }
        };
        // if we have einstein elements
        if (einsteinElements.length > 0) {
            einsteinElements.forEach((el) => {
                var observer = new MutationObserver(mutationCallback);
                observer.observe(el, { childList: true });
            });
        }
    },
    categorySubFolder: function () {
        $('.category-subfolder-tile-caro').on('init reInit', function (event, slick) {
            slickConfigs.reinitPagination(event, slick, imagesPerRow);
        }).slick(slickConfigs.categorySubFolderTiles);
        util.smartResize(function () {
            slickConfigs.reinitPagination(event, $('.category-subfolder-tile-caro').slick('getSlick'), imagesPerRow);
        });
    },
    productRelatedContent: function () {
        $('.product-related-content-tile-caro').slick(slickConfigs.productRelatedContent);
    },
    caroMobileOnly: function () {
        var $caroMobileOnly = $('.caro-mobile-only');
        var unslick = function () {
            if ($caroMobileOnly.hasClass('slick-initialized')) {
                $caroMobileOnly.slick('unslick');
            }
        };
        if ($caroMobileOnly.length) {
            util.smartResize(function () {
                if (util.mediaBreakpointDown('md')) {
                    $caroMobileOnly.not('.slick-initialized').slick(slickConfigs.caroMobileOnly);
                } else {
                    unslick();
                }
            });
        }
    }
};
